import App from '@/models/App'

export default class TrafficShipWork extends App {
    static get entity() {
        return 'TrafficShipWorks'
    }

    static all() {
        return this.query().withAllRecursive().where('isDeleted', false).get()
    }

    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            name: this.attr(''),
            background: this.attr(''),
            isLock: this.attr(''),
            isDeleted: this.attr(''),
            sortNum: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`traffic/ship/works`, {
                    params: { all: true },
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            save(params) {
                return this.post(
                    `/traffic/ship/works/saved`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficShipWorkId) {
                return this.delete(`traffic/ship/work/${trafficShipWorkId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    delete: trafficShipWorkId,
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
